import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const GRID_FILTER_IDENTIFIER = 'gridStatus'

const gridFilter = (source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.9_box'),
    path: 'gridStatus',
    identifier: GRID_FILTER_IDENTIFIER,
    type: FilterType.String,
    default: false,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: [
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.1'), value: '1' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.2'), value: '2' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.3'), value: '3' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.4'), value: '4' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.5'), value: '5' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.6'), value: '6' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.7'), value: '7' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.8'), value: '8' },
          { label: i18n.t('performance_process.analytics.nine_box_grid.scores.9'), value: '9' },
        ],
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: GRID_FILTER_IDENTIFIER,
        value,
      })
    },
  })
}

export default gridFilter
